import React, { useCallback } from "react";

export function useChatScroll<T>(
  dep: T
): React.MutableRefObject<HTMLDivElement | undefined> {
  const ref = React.useRef<HTMLDivElement>();
  const updateScrollBar = useCallback(() => {
    if (ref.current) {
      ref.current.scrollIntoView();
    }
  }, []);
  React.useEffect(() => {
    updateScrollBar();
    // JSON.stringify to handle  deep compare
  }, [JSON.stringify(dep)]);

  return ref;
}
